import axios from "axios";
import { getUrlConfig } from "../common/urlCreator/urlConfig";

const urlConfig = getUrlConfig();

/**
 * 会員情報
 */
export type UserInfo = {
  auth_id: string,
  prsnl_id: string,
  usr_namej: string
}

/**
 * 会員情報取得
 * 
 * @param {string} prsnl_id - 紐付けID
 * @returns {UserInfo}
 */
export const findUserByPrsnlId = async (prsnl_id:string) => {
  const res = await axios.get<UserInfo>(
    `${urlConfig.SONET_GYOM_API_CS}/user_search/api/user?prsnl_id=${prsnl_id}`,
    {withCredentials: true}
  );
  return res.data;
}